export const GRAPESJS_PPFX = "gjs-";

export const globalEventListener = "sp-global-event-listener";
export const pageAdaptor = "sp-page-adaptor";
export const globalEventName = "dashboard";
export const GLOBALEVENTS = {
  NAVIGATE: 'NAVIGATE'
};

export const ledRef = 'xly-led'
export const buttonGroupRef = 'xly-btnGroup'
export const textRef = 'xly-text'
export const rangeRef = 'xly-range'

export const imgBase64Ref = 'xly-imgBase64'
export const boxRef = 'xly-box'
export const headerRef = 'xly-header'
export const iframeRef = 'xly-iframe'
export const headline1 = "head-line"
export const headline = "head-line2"
export const fontAwesome = "font-awesome"
export const iconFont = "spicon"
export const tagItem = "tag-item"
export const cardStatus = "card-status"
export const Progress = "progress-comp"
export const Button = "button-comp"
export const CurrentTime = "current-time"
export const Modal = "modal-comp"
export const LayoutTable = "layoutTable"
export const IconAnt = "iconAnt"

export const CustomTime = "custom-time"
export const Weather = "weather"
export const customCarousel = 'xly-customCarousel'
export const linearRegressionScatterChart = "linear-regression-scatter-Chart"
export const barGroupChart = "bar-group-Chart"
export const pictorialBarLineChart = "pictorialBar-line-Chart"
export const pictorialBarLineCategoryChart = "pictorialBar-line-category-Chart"
export const circularProgress = 'circular-progress'
export const hoopRef = 'xly-hoop'

export const pathImage = "path-image"
export const CustomVideo = 'custom-video'
export const relativeLink = 'relative-link'
export const spCode = 'sp-code';

export const pieChart = "pie-Chart"
export const barChart = "bar-Chart"
export const funnelChart = "funnel-Chart"
export const lineChart = "line-Chart"
export const lineMarkPointChart = "line-MarkPoint-chart"
export const closeLineChart = "close-line-Chart"
export const barLineChart = "bar-line-Chart"
export const pictorialBarChart = "pictorialBar-Chart"
export const rectStackBarChart = "rectStackBar-Chart"
export const ringChart = "ring-Chart"
export const gaugeChart = "gauge-chart"
export const scatterChart = "scatter-Chart"
export const piecescatterChart = "piece-scatter-Chart"
export const polarBarChart = "polar-bar-Chart"
export const singleRingChart = "single-ring"
export const heatmapChart = "heatmap"
export const heatmapChart2 = "heatmap-calendar-Chart"
export const map3D = "map3D-Chart"
export const map3DPopup = "map3DPopup-Chart"
export const map2DPopup = "map2DPopup-Chart"
export const mapScatter = "mapScatter-Chart"
export const mapHeatmapChart = "mapHeatmap"
export const radarChart = 'radar-Chart'
export const oscilloscope = 'oscilloscope'

export const form = "form-panel"
export const formSelect = "form-select"
export const select = "select-comp"
export const formInput = "form-input"
export const groupText = "group-text"
export const dynamicText = "dynamic-text"
export const multiFunDynamicText = "scenario-dynamic-text"
export const groupLed = "group-led"
export const dynamicLed = "dynamic-led"
export const label = "label"
export const buttonSwitch = "switch-comp"
export const formSwitch = "form-switch"
export const checkfile = "check-file"
export const dateRangePicker = "date-range-picker"
export const dateRangePickerInput = "date-range-picker-input"
export const rating = 'rating'
export const horizontalRule = 'horizontal-rule'
export const multiline = 'multiline'
export const cascadeAddress = 'cascade-address'
export const geolocation = 'geolocation'
export const checkboxGroup = 'checkbox-group'
export const phone = 'phone'

export const richText = 'rich-text'
export const jsonViewer = 'json-viewer'
export const navTags = 'nav-tags'
export const jSlider = 'jq-slider'

export const mdcRadio = "mdc-radio"
export const mdcRadioGroup = "mdc-radio-group"
export const mdcCheckbox = "mdc-checkbox"
export const mdcCheckboxGroup = "mdc-checkbox-group"
export const mdcTextField = "mdc-textfield"
export const mdcSelect = "mdc-select"
export const mdcSlider = "mdc-slider"

export const mdTable = "mdc-table"
export const tableSimple = "table-simple"
export const list = "list-comp"

export const cardSetting = 'card-setting'

export const appPopover = 'app-popover'

// 卡片列表
export const cardList = 'xly-card-list'

// 甘特图
export const ganteRef = 'xly-gante-chart'
// 自定义svg
export const customSVG = 'xly-svg'
// 流计算
export const streamComputing = 'xly-streamComputing'
// 检测结果
export const detectionResultRef = 'xly-detection-result'
export const textDefaultListen = "change:align change:writingMode change:size change:weight change:color change:bgColor "

export const bidirectionalBarChart = 'BidirectionalBar-Chart'
export const doubleRingChart = 'doubleRing-Chart'
// 行业场景-飞机制造
export const aircraftIndustryClass = 'aircraft-industry-class'
// 图标场景-地图
export const mapClass = "mapClass"

export const animatePieChart = "animate-pie"
export const rankingList = "ranking-list"


/************************ 组件名 ************************/

/************* 控件 *************/
export const Input = "sp-control-input"
export const input = "input-comp"

// 文件上传
export const uploadRef = 'sp-upload'
export const uploadRefBtn = 'sp-upload-btn'
export const uploadRefViewBtn = 'sp-upload-view-btn'
export const uploadRefInfo = 'sp-upload-info'

export const Record = "sp-record"

/************* 隐藏 *************/
export const ReservedInput = 'input-comp';

export const CATEGORIES = {
  COMMON: '通用',
  CONTROL: '控件',
  FORM: '表单',
  TABLE: '表格',
  INVISIBLE: '隐藏',
  MATERIALS: '素材',
  ECHARTS: '图表',
  MEDIA: '媒体',
  MAPS: '地图',
  OTHER: '其他',
}

export const BLOCK_SEQUENCE = [
  // 通用
  '标题', '文本', '多行文本', '标签', 'JSON显示',
  '分割线', '标签组',
  '时间', '跑马灯', '数字翻牌器', '二维码', '状态卡片', '进度条', '天气', '排名', '倒计时', '时间轴'
  ,
  // 控件
  '输入框', '按钮', 'Link Button', '开关', '单选', '多选', '选择框', '上传文件',
  '标签页', '页面跳转', '项目预览',
  '滑块', '富文', '评分', '地址', '定位', '手机号', '弹窗'
  ,

  // 表格
  '表格'
  ,

  // 图表
  '线形图', '线形标注图', '包线图', '示波器',
  '柱形图', '双向柱形图', '柱线图', '方块堆叠图', '象形柱图', '极坐标柱形图',
  '饼图', '动态饼图', '双环形图', '占比单环',
  '连续型散点图', '离散型散点图',
  '仪表盘', '雷达图', '漏斗图', '甘特图'
  ,

  // 媒体
  '图片', '路径图片', '视频', '录音组件'
  ,

  // 地图
  '3D中国地图', '散点地图', '弹框3D地图', '热力图直角坐标系', '热力图日历坐标系', '热力图地图坐标系', '下钻热力弹框平面地图'
  ,

  // 素材
  '图标', '灯', '组合灯'
  ,

  // 其他
  '自定义代码'
]

